import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { SearchBar } from './components/SearchBar';
import { QuickActions } from './components/QuickActions';
import { StatsSection } from './components/StatsSection';
import { ServicesSection } from './components/ServicesSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col font-heading bg-background text-foreground" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-1" data-id="element-2">
        <HeroSection data-id="element-3" />
        <SearchBar data-id="element-4" />
        <QuickActions data-id="element-5" />
        <StatsSection data-id="element-6" />
        <ServicesSection data-id="element-7" />
        <FAQSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}